<div class="modal-header">
    <div class="d-flex align-items-center">
        <div class="me-2" *ngIf="!user.backgroundImage">
            <div class="avatar avatar-md">{{user.initials}}</div>
        </div>
        <div class="me-2" *ngIf="user.backgroundImage">
            <div class="avatar avatar-md" [ngStyle]="{'background-image': user.backgroundImage}"></div>
        </div>
        <h3 class="m-0 text-strong">{{user.fullName}}</h3>
    </div>
    <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
</div>
<div class="modal-body">
    <dirty-tracking [forms]="[assignmentForm]"></dirty-tracking>
    <form novalidate #assignmentForm="ngForm" [ngClass]="{'was-validated': submitAttempt}" [ngSwitch]="stepNumber">
        <label class="form-label text-medium" *ngSwitchCase="1">Assign User to</label>
        <div class="row gx-2 mb-4" *ngSwitchCase="1">
            <div class="col-md mb-3 mb-md-0 mobiscroll-select">
                <label class="form-label d-block">Top Level Account <sup class="text-danger">*</sup></label>
                <input id="move-account-input" class="mobi-input form-control form-control-lg" required placeholder="Select Account" mbsc-select [data]="accounts" [(ngModel)]="accountId" name="accountId" [mbscOptions]="accountOptions" />
            </div>
            <div class="col-md mb-3 mb-md-0 mobiscroll-select">
                <label class="form-label d-block">Entity</label>
                <input id="move-parent-input" class="mobi-input form-control form-control-lg" placeholder="Select Entity" mbsc-select [data]="parents" [(ngModel)]="parentId" name="parentId" [mbscOptions]="parentOptions" />
            </div>
        </div>
        <div class="row gx-2 mb-4" *ngSwitchDefault>
            <div class="row gx-2 mb-4">
                <h4 class="mb-1 text-strong">Assign User to:</h4>
                <nav aria-label="breadcrumb" class="small">
                    <ol class="breadcrumb mb-0">
                        <li class="breadcrumb-item" *ngFor="let h of assignment.hierarchy"><i class="far fa-folder"></i>
                            {{h.text}}</li>
                    </ol>
                </nav>
            </div>
            <h5 class="mb-2">Assign User...</h5>
            <div class="row gx-2 mb-4">
                <div class="col">
                    <button type="button" class="btn btn-outline-black btn-lg w-100" [ngClass]="{'active': !assignment.passToChildren}" (click)="assignment.passToChildren = false">Only Here</button>
                </div>
                <div class="col">
                    <button type="button" class="btn btn-outline-black btn-lg w-100" [ngClass]="{'active': assignment.passToChildren}" (click)="assignment.passToChildren = true">To
                        All Inherited
                        Entities</button>
                </div>
            </div>
            <h5 class="mb-3 text-medium" *ngIf="assignment.hierarchy.length > 0">Set this user's permissions for all
                entities
                under<br />"{{assignment.hierarchy[assignment.hierarchy.length - 1].text}}"
            </h5>
            <input type="text" name="permissions" class="mobi-input form-control form-control-lg" mbsc-select required [data]="permissions" [(ngModel)]="assignment.permissions" [mbscOptions]="permissionOptions" [ngClass]="{'is-invalid': assignment.permissions.length == 0 && submitAttempt}" />
            <div class="invalid-feedback">
                <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
        </div>
    </form>
</div>
<div class="modal-footer" [ngSwitch]="stepNumber" *ngIf="accountId || assignment.entityId">
    <button type="button" class="btn btn-secondary btn-round btn-lg" *ngSwitchCase="1" (click)="nextStep()">Continue <i class="far fa-arrow-right"></i></button>
    <button type="button" class="btn btn-outline-black btn-round btn-lg" *ngSwitchCase="2" (click)="previousStep()"><i class="far fa-chevron-left"></i> back</button>
    <button type="button" class="btn btn-secondary btn-round btn-lg" *ngSwitchCase="2" (click)="saveAssignment()"><i class="far fa-check"></i> Assign User</button>
    <button type="button" class="btn btn-secondary btn-round btn-lg" *ngSwitchCase="3" (click)="saveAssignment()"><i class="far fa-check"></i> Assign User</button>
</div>